import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import PhoneIcon from "../../../assets/Icons/PhoneIcon"
import { ActivityIndicator, Platform, ScrollView, View } from "react-native"
import Button from "@app/sharedComponents/Button/Button"
import { useEffect, useState } from "react";
import { useAppSelector } from "@app/store/hooks"
import { LENDER_ID } from "@app/types/regix"
import { endpoints } from "@app/api/apis"
import axios from "axios";
import ROUTE from "@app/navigationApp/routes"
import { PaymentStatuses } from "../ConfirmPay/ConfirmPay"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { BottomTabParamList, PrivateStackParamList } from "@app/navigationApp/types"
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
// import Warning from "assets/Icons/Warning"
import { formatIndianCurrency } from "@app/utils/utility"
import { getPaymentMode, REPAYMENT_COLLECTION_TYPE } from "./utils"
import NumStepper from "@app/sharedComponents/NumStepper/NumStepper"
import fetchUserDetails from "@app/helper/fetchUserInfo"
import TataPaymentStatus from "./components/TataPaymentStatus"
import dayjs from "dayjs"
import DspPaymentStatus from "./components/DspPaymentStatus"
import { DSP_PAYMENT_STATUS, removePathFromUrlWithouReload, removeUrlWithoutReload } from "@app/utils"
import ActionStepper from "@app/sharedComponents/ActionStepper/ActionStepper";

type PaymentData = {
    totalAmountDue?: number;
    lastUpdatedOn?: any;
    paymentDate?: any,
    collectionStatus?: any,
    transactionId?: string,
    pgResponseDetails?: any,
    collectionType?: string
};

type ScreenProps = NativeStackScreenProps<PrivateStackParamList & BottomTabParamList, 'PAYMENT_STATUS'>;

const FooterComp = ({navigation, redirectingRoute, lenderId, userPaymentData}: {
    navigation: any;
    redirectingRoute: any;
    lenderId: string;
    userPaymentData: PaymentData;
}) => {
    // ... existing code ...
    const paymentStatus = userPaymentData?.collectionStatus;
    const isPaymentSuccessful = paymentStatus === PaymentStatuses.COLLECTION_COMPLETE || 
                               paymentStatus === PaymentStatuses.SETTLED || 
                               paymentStatus === PaymentStatuses.SUCCESS_WITH_LENDER_RECON_FAILED;
    const isPaymentFailure = paymentStatus === PaymentStatuses.FAILED;
    const isPaymentCancelled = paymentStatus === PaymentStatuses.CANCELLED;
    const isPaymentPending = paymentStatus === PaymentStatuses.PENDING_SETTLEMENT;

    // Collection type checks
    const isFromForeclosure = userPaymentData?.collectionType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE;
    const isFromLoanRenewal = userPaymentData?.collectionType === REPAYMENT_COLLECTION_TYPE.LOAN_EXPIRED_DUE_REPAYMENT;
    const isFromPrincipalRepay = userPaymentData?.collectionType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT;
    const isFromInterestCollection = userPaymentData?.collectionType === REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION;
    const isFromShortfall = userPaymentData?.collectionType === REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT;
    const showNewForeclosureScreen = true;

    // Determine button label
    const getButtonLabel = () => {
        if (isPaymentSuccessful && isFromForeclosure && showNewForeclosureScreen) {
            return 'Continue loan closure';
        }
        if (isPaymentSuccessful || isPaymentPending) {
            return 'Done';
        }
        if (isPaymentFailure || isPaymentCancelled) {
            return 'Retry payment';
        }
        return 'Done';
    };

    // Determine action type
    const getActionType = () => {
        if (isPaymentSuccessful && isFromForeclosure && showNewForeclosureScreen) {
            return 'NAVIGATE_TO_FORECLOSURE';
        }
        if (isPaymentSuccessful && isFromLoanRenewal) {
            return 'REDIRECT_ACTION';
        }
        if (isFromLoanRenewal) {
            return 'RETRY_PAYMENT_LOAN_EXPIRED';
        }
        if (isPaymentSuccessful || isPaymentPending) {
            return 'REDIRECT_ACTION';
        }
        if (isFromPrincipalRepay) {
            return 'RETRY_PAYMENT';
        }
        if (isFromInterestCollection) {
            return 'RETRY_INTEREST_COLLECTION_PAYMENT';
        }
        if (isFromShortfall) {
            return 'RETRY_PAYMENT_SHORTFALL';
        }
        if (isFromForeclosure) {
            return 'RETRY_PAYMENT_FORECLOSURE';
        }
        return 'RETRY_PAYMENT';
    };

    // Handle navigation based on action type
    const handleButtonPress = () => {
        const actionType = getActionType();
        const routeObject = {
            'NAVIGATE_TO_FORECLOSURE': ROUTE.CONFIRM_LOAN_DETAILS,
            'REDIRECT_ACTION': ROUTE.DASHBOARD_SCREEN,
            'RETRY_PAYMENT_LOAN_EXPIRED': ROUTE.DASHBOARD_SCREEN,
            'RETRY_PAYMENT': ROUTE.FLEXI_PAY,
            'RETRY_INTEREST_COLLECTION_PAYMENT': ROUTE.DASHBOARD_SCREEN,
            'RETRY_PAYMENT_SHORTFALL': ROUTE.SHORTFALL_REPAY,
            'RETRY_PAYMENT_FORECLOSURE': ROUTE.HOW_TO_CLOSE_ACCOUNT,
        }
        if(routeObject[actionType]!==ROUTE.DASHBOARD_SCREEN){
            navigation.reset({
                routes: [{ name: ROUTE.HOME }, { name: routeObject[actionType] }],
              });
        }else{
            Platform.OS === "web" ? removeUrlWithoutReload("uid") : {}
            Platform.OS === "web" ? removePathFromUrlWithouReload("pgCallBack") : {}
            navigation.navigate(ROUTE.HOME);
        }
    };

    const handleSkipForNow = () => {
        Platform.OS === "web" ? removeUrlWithoutReload("uid") : {}
        Platform.OS === "web" ? removePathFromUrlWithouReload("pgCallBack") : {}
        navigation.navigate(ROUTE.HOME);
    }

    
    if (lenderId?.toLowerCase() === LENDER_ID.BAJAJ && isPaymentSuccessful) {
        return (
            <ThemedView p="lg" style={{backgroundColor: '#fff'}}>
                <Button 
                    size="MD" 
                    type='SOLID' 
                    label='Done' 
                    handlePress={handleSkipForNow} 
                />
            </ThemedView>
        );
    }

    
    if (lenderId?.toLowerCase() === LENDER_ID.DSP && !isPaymentSuccessful) {
        return (
            <ThemedView p="lg" style={{backgroundColor: '#fff'}}>
                <ThemedView>
                    <Button 
                        size="MD" 
                        type='SOLID' 
                        label='Retry payment' 
                        handlePress={handleButtonPress} 
                    />
                </ThemedView>
                {paymentStatus !== DSP_PAYMENT_STATUS.IN_PROGRESS && (
                    <ThemedView style={{marginTop: 16}}>
                        <Button 
                            size="MD" 
                            type='OUTLINED' 
                            label='Skip for now' 
                            handlePress={handleSkipForNow} 
                        />
                    </ThemedView>
                )}
            </ThemedView>
        );
    }

    
    return (
        <ThemedView p="lg" style={{backgroundColor: '#fff'}}>
            <Button 
                size="MD" 
                type='SOLID' 
                label={getButtonLabel()}
                overRideStyle={{marginBottom:8}}
                handlePress={handleButtonPress}
            />
            {(isPaymentFailure || isPaymentCancelled) && (
                <ThemedView my ='lg' alignItems="center">
                    <Button 
                        size="MD" 
                        type='TEXT' 
                        label='Skip for now'
                        handlePress={handleSkipForNow}
                    />
                </ThemedView>
            )}
        </ThemedView>
    );
};

const renderBajajPaymentStatusScreen = (userPaymentData: PaymentData) => {
    const paymentStatus = userPaymentData?.collectionStatus
    const isPaymentSuccessful = paymentStatus === PaymentStatuses.COLLECTION_COMPLETE || paymentStatus === PaymentStatuses.SETTLED || paymentStatus === PaymentStatuses.SUCCESS_WITH_LENDER_RECON_FAILED
    const isPaymentFailure = paymentStatus === PaymentStatuses.FAILED
    const isPaymentPending = paymentStatus === PaymentStatuses.PENDING_SETTLEMENT;
    const isPaymentCancelled = paymentStatus === PaymentStatuses.CANCELLED;
    
    const epochFromBackend = userPaymentData?.paymentDate
    const transactionalRefNumber = userPaymentData?.transactionId !== null ? userPaymentData?.transactionId : "Not applicable";
    const bankRefNumber = userPaymentData?.pgResponseDetails !== null && userPaymentData?.pgResponseDetails?.bankRefNo !== null
            ? userPaymentData?.pgResponseDetails?.bankRefNo
            : "Not applicable"
    const paymentMode = 
            userPaymentData?.pgResponseDetails?.paymentMode 
                ? userPaymentData?.pgResponseDetails?.paymentMode === "Unified Payments"
                    ? "UPI" 
                    : getPaymentMode(userPaymentData?.pgResponseDetails?.paymentMode)
                : "Not applicable"
    
    const dateFromBackend = new Date(userPaymentData?.paymentDate)
    const options = {
        timeZone: 'Asia/Calcutta',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
    };
    //@ts-ignore
    const istTime = dateFromBackend.toLocaleString('en-US', options);
    const paymentDate = epochFromBackend !== null
         ? `${dateFromBackend.toDateString().substring(4, dateFromBackend.toDateString().length - 5)}, ${dateFromBackend.toDateString().substring(dateFromBackend.toDateString().length - 4)} ${istTime}`
         : "";

    const amountCollected = userPaymentData?.totalAmountDue ? `₹${formatIndianCurrency(userPaymentData.totalAmountDue)}` : "Not applicable";

    const stepperData = [
        {
            "status": "COMPLETED",
            "verticalDisplayName": "Payment accepted for settlement",
            "verticalDescription": `Paid via ${paymentMode} on ${paymentDate}`,
            "order": 0,
            "highLightText": false
        },
        {
            "status": "SUCCESS",
            "verticalDisplayName": "Settlement under processing",
            "verticalDescription": "It may take up to 2 working days for the payment to reflect in the statement. Don't worry, no additional interest will be charged.",
            "order": 1,
            "highLightText": true
        }
    ];

    if (isPaymentSuccessful) {
        return (
            <ThemedView style={{marginTop:36}}>
                <ThemedView style={{paddingHorizontal:16,paddingTop:16,borderRadius:16,borderWidth:1,borderColor:'#E4E7EC'}}>
                    <ThemedText variant="b1r" color="text-secondary">
                        Repayment amount
                    </ThemedText>
                    <ThemedView style={{flexDirection:'row'}}>
                        <ThemedText variant="l1" color="text-primary">
                            ₹
                        </ThemedText>
                        <ThemedText variant="h1b" color="text-primary">
                            {amountCollected ? amountCollected.substr(1):""}
                        </ThemedText>
                    </ThemedView>
                    <ThemedView backgroundColor="border-primary" mt ='lg' width="100%" height={1}/>
                    <ThemedView style={{marginBottom:24,marginHorizontal:-16}}>
                    </ThemedView>
                    {stepperData.map((item, index) => (<ActionStepper data={item} key={index} showBottomLeftLine={index <stepperData.length-1}/>))}
                </ThemedView>
                <ThemedView style={{marginTop:16}}>
                    <ThemedText variant="b2r" color="text-secondary">
                        Transaction reference number
                    </ThemedText>
                    <ThemedText variant="b1m" color="text-primary">
                        {transactionalRefNumber}
                    </ThemedText>   
                </ThemedView>
                <ThemedView backgroundColor="border-primary" my ='lg' width="100%" height={1}/>
                <ThemedText variant="b2r" color="text-secondary">
                    Payment mode
                </ThemedText>
                <ThemedText variant="b1m" color="text-primary">
                    {paymentMode}
                </ThemedText>  
            </ThemedView>
        )
    }

    const label = isPaymentFailure ? 'Payment failed' : isPaymentCancelled ? "Payment failed": 'Payment in progress';

    return (
        <ThemedView style={{marginTop:24}}>
            <ThemedView style={{alignItems:'center'}}>
                <PhoneIcon size={24} />
            </ThemedView>
            
            <ThemedView mt="lg" style={{alignItems:'center'}}>
                <ThemedText variant="b4r" color="text-secondary">
                    {label}
                </ThemedText>
            </ThemedView>
            <ThemedView mt ='sm' style={{alignItems:'center'}}>
                <ThemedText>
                    ₹{userPaymentData?.totalAmountDue}
                </ThemedText>
            </ThemedView>
            <ThemedView mt = 'lg' style={{alignItems:'center'}}>
                <ThemedText>
                    {paymentDate}
                </ThemedText>
            </ThemedView>
            {(isPaymentPending || isPaymentCancelled || isPaymentFailure) && (
                <ThemedView mt = 'lg' style={{flexDirection:'row',backgroundColor:'#FEF4E6',paddingHorizontal:16,paddingVertical:8,borderRadius:8}}>
                    <ThemedText>
                        <ThemedText variant='b4s' color='text-primary'>
                            Note:{' '}
                        </ThemedText>
                        <ThemedText variant='b4r' color='text-primary'>
                            {isPaymentPending 
                                ? "Your repayment is being processed. Please wait while we confirm the status of your transaction."
                                : "Any amount deducted from your account will be refunded to your account in 5-7 business days."
                            }
                        </ThemedText>
                    </ThemedText>
                </ThemedView>
            )}
            <ThemedView mt="xl" p="lg" borderRadius="sm" style={{backgroundColor: '#F9FAFB', borderWidth: 1, borderColor: '#E4E7EC'}}>
                <ThemedView>
                    <ThemedText variant="b4r" color="text-secondary">
                        Transaction reference number
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {transactionalRefNumber}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView mt="lg">
                    <ThemedText variant="b4r" color="text-secondary">
                        Bank reference number
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {bankRefNumber}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView mt="lg">
                    <ThemedText variant="b4r" color="text-secondary">
                        Payment Method
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {getPaymentMode(paymentMode)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
        </ThemedView>
    )
}




const PaymentStatus = ({navigation,route} : ScreenProps)=>{

    const { collectionId = "", dspPaymentStatus = "", currentOrderId = "", redirectingRoute = "",isPgCallback = "" } = route?.params ?? {};

    let failedTitle = 'Any amount deducted will be refunded by your bank in 3-5 business days.'
    let progressTitle = 'Your repayment is being processed. Please wait while we confirm the status of your transaction.';


    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const lenderId = userDetails?.linkedCredits[0]?.lendingPartnerId;
    const [userPaymentData,setuserPaymentData] = useState<PaymentData>({});
    const [isLoading, setIsLoading] = useState(true);

    const userCollectionId = isPgCallback ? isPgCallback : collectionId
    let currentLender = userDetails?.linkedCredits[0]?.lendingPartnerId;

    const renderDspPaymentStatus = ()=>{
        const url = endpoints.dspPaymentCallback + userCollectionId       
        axios.get(url).then((res)=>{
          setuserPaymentData(res?.data)
          setIsLoading(false);
        }).catch((err)=>{
          console.log('error in getting dsp payment details data',err)
          setIsLoading(false);
        })
    }

    const renderPaymentStatus = ()=>{
        const url = endpoints.paymentCallback + userCollectionId       
        axios.get(url).then((res)=>{
          setuserPaymentData(res?.data)
          setIsLoading(false);
        }).catch((err)=>{
          console.log('error in getting payment details data',err)
          setIsLoading(false);
        })
    }

    useEffect(() => {
        fetchUserDetails()
        if (currentLender.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
            renderDspPaymentStatus();
        } else {
            renderPaymentStatus();
        }
    },[dspPaymentStatus])

    const dspAmountCollected = userPaymentData?.totalAmountDue;
    const epochDspPaymentDate = userPaymentData?.lastUpdatedOn;
    // const isPaymentCancelled = paymentCancelled ? paymentCancelled : paymentStatus === PaymentStatuses.CANCELLED


    return isLoading ? <ActivityIndicator size="large" color="#0000ff" /> :
    (
        <>
            <ScrollView style={{flex:1,backgroundColor:'#fff', padding:16}}>
            {lenderId?.toLowerCase() === LENDER_ID.TATA && <TataPaymentStatus userPaymentData={userPaymentData} />}
            {lenderId?.toLowerCase() === LENDER_ID.BAJAJ && renderBajajPaymentStatusScreen(userPaymentData)}
            {lenderId?.toLowerCase() === LENDER_ID.DSP && 
            <DspPaymentStatus 
                dspPaymentStatus={dspPaymentStatus}
                currentOrderId={currentOrderId}
                dspAmountCollected={dspAmountCollected}
                dspPaymentDate={dayjs(userPaymentData?.lastUpdatedOn).format("MMM DD, YYYY HH:mm A")}
                failedTitle={failedTitle}
                progressTitle={progressTitle}
                userPaymentData={userPaymentData}
            />}
            </ScrollView>
            <FooterComp navigation={navigation} redirectingRoute={redirectingRoute} lenderId={lenderId} userPaymentData={userPaymentData} />
        </>
    )   
}

export default PaymentStatus